import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user clicks o "Next" button in search results in transcript panel',
  name: 'next_result_clicked',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Search term',
      name: 'search_term',
      required: true,
      type: 'string',
    },
    {
      description: 'New search result index',
      name: 'new_index',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
